export const setDocumentClass = (className, isSet) => {
  if (isSet) {
    document.querySelector("html").classList.add(className);
    document.querySelector("body").classList.add(className);
  } else {
    document.querySelector("html").classList.remove(className);
    document.querySelector("body").classList.remove(className);
  }
};

export const isDescendantOf = (child, parent) => {
  var node = child.parentNode;
  while (node != null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/utils/ui-utils.js